




















import { reactive, computed, defineComponent, SetupContext } from '@vue/composition-api';
import { RouteConfig } from 'vue-router';

const Component = defineComponent({
  name: 'MainMenu',

  setup(_, { root: { $router } }: SetupContext) {
    const state = reactive({
      items: computed(() =>
        getRoutes().filter(
          (route: RouteConfig) =>
            route.meta?.isSidebarItem || route.meta?.isSidebarItem === undefined,
        ),
      ),
    });

    function getRoutes() {
      //get children of root path ('/')
      return ($router as any).options.routes[0].children;
    }

    function version() {
      return process.env.VUE_APP_VERSION;
    }

    return {
      state,
      version,
    };
  },
});

export default Component;
